export class Company {
  id: string;
  fiscalName: string;
  offices: Office[];
}

export class Office {
  id: number;
  randstadOffice: number;
  name: string;
  selectName: string;
  address: string;
  addressStreet: string;
  addressNumber: string;
  addressZipCode: string;
  provinceName: string;
  cityName: string;
  latitude: number;
  longitude: number;
  phone: string;
  fax: string;
  districtId: string;
  districtName: string;
  regionId: number;
  regionName: string;
  companyId: string;
  companyName: string;
  brandId: number;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
  businessAreas: string[];
  businessAreaIds: number[];
}

export class RandstadCompany {
  companyId: string;
  fiscalName: string;
  boCompanyId: string;
  regions: RandstadRegion[];
}

export class RandstadRegion {
  regionId: number;
  name: string;
  districts: RandstadDistrict[];
}

export class RandstadDistrict {
  districtId: string;
  name: string;
  branches: RandstadBranch[];
}

export class RandstadBranch {
  id: number;
  branchId: string;
  name: string;
}
